import React from "react";
import PropTypes from "prop-types";

import "../css/bootstrap.min.css";
import "../css/styles.css";
import "../css/custom.css";
import "../css/slider-animation.css";

import Header from "./header";
// import "bootstrap/dist/css/bootstrap.min.css";

const Layout = ({ children }) => {
  return (
    <>
      <main className="main-wrapper" style={{ marginTop: "-22px" }}>
        <Header />
        <div className="content-wrapper oh">{children}</div>
      </main>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
